/* ============
 * Getters for the tracking module
 * ============
 *
 * The getters that are available on the
 * tracking module.
 */

import { getField } from 'vuex-map-fields';

export default {
  // Add the `getField` getter to the
  // `getters` of your Vuex store instance.
  getField,
};
